import { maxDisplayWidth, canvasAspectRatio } from "../constants/canvas";
import { getAssetPath } from "../utils/assetPath";

export default function () {
  return {
    type: "card",
    variant: "plastic-white", // Default variant
    frontConfig: {
      canvas: {
        backgroundColor: "#fff",
        width: getCanvasWidth(),
        height: getCanvasWidth() / canvasAspectRatio,
        selection: false,
        preserveObjectStacking: true,
        moveCursor: "move",
        hoverCursor: "default",
      },
      helperCanvas: {
        width: getCanvasWidth() + 50,
        height: getCanvasWidth() / canvasAspectRatio + 50,
        containerClass: "helperCanvas",
        selection: false,
        preserveObjectStacking: true,
      },
      chip: {
        id: "default-chip",
        src: getAssetPath("/assets/images/chip.png"),
        scaleX: 0.41,
        scaleY: 0.42,
        left: 95,
        top: 183,
        selectable: false,
        evented: false,
        hasControls: false,
        hasBorders: false,
        lockMovementX: true,
        lockMovementY: true,
        lockRotation: true,
        lockScalingX: true,
        lockScalingY: true,
        hoverCursor: "default",
        crossOrigin: "anonymous",
        absolutePositioned: true,
      },
    },
    backConfig: {
      canvas: {
        backgroundColor: "#fff",
        width: getCanvasWidth(),
        height: getCanvasWidth() / canvasAspectRatio,
        selection: false,
        preserveObjectStacking: true,
        moveCursor: "move",
        hoverCursor: "default",
      },
    },
  };
}

function getCanvasWidth() {
  // 24px spacing each side (48 total), aligned with canvasSetupMixin
  return Math.min(document.body.clientWidth - 48, maxDisplayWidth);
}
